module.exports = __webpack_public_path__ + "static/media/model-navara-d40.ee42f5ea.webp";